export default __webpack_public_path__ + "static/media/compas_project_send_attestation.e303c7d3.gif";